import styled from 'styled-components';
import { lightGrey2Color, lightGrey1Color } from 'js/config/style';
import Icon from 'js/components/common/Icon';

export default styled(Icon)`
  color: ${lightGrey2Color};
`;
